var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { customElement, property } from 'lit/decorators.js';
import { html, nothing } from 'lit';
import { BwElement } from './base/bw-element.js';
let BwInput = class BwInput extends BwElement {
    constructor() {
        super(...arguments);
        this.type = 'text';
        this.value = '';
        this.placeholder = '';
        this.disabled = false;
        this.mono = false;
        this.invalid = false;
        this.unit = '';
        this.inputmode = '';
        // Callers (bw-field, for its error) set `aria-describedby` on the HOST; the host
        // is a generic element, so it only reaches AT if it is forwarded to the native
        // input — the same reason bw-button forwards aria-expanded. No `reflect`: the
        // host attribute stays as written.
        this.fwdDescribedBy = null;
    }
    _onInput(e) {
        this.value = e.target.value;
        this.dispatchEvent(new CustomEvent('bw-input-input', {
            detail: { value: this.value }, bubbles: true, composed: true,
        }));
    }
    _onChange(e) {
        this.value = e.target.value;
        this.dispatchEvent(new CustomEvent('bw-input-change', {
            detail: { value: this.value }, bubbles: true, composed: true,
        }));
    }
    // Light DOM: the native input is a child, not a shadow node. Delegating focus
    // lets callers drive focus across a row of inputs (the six OTP cells) without
    // reaching into internals.
    focus(options) {
        const el = this.querySelector('input.bw-input-native');
        if (el)
            el.focus(options);
        else
            super.focus(options);
    }
    render() {
        return html `
      <span class="bw-input-slot">
        <input
          class="bw-input-native ${this.mono ? 'mono' : ''}"
          type=${this.type}
          .value=${this.value}
          placeholder=${this.placeholder || nothing}
          ?disabled=${this.disabled}
          aria-invalid=${this.invalid ? 'true' : nothing}
          aria-describedby=${this.fwdDescribedBy ?? nothing}
          min=${this.min ?? nothing}
          max=${this.max ?? nothing}
          step=${this.step ?? nothing}
          maxlength=${this.maxlength ?? nothing}
          inputmode=${this.inputmode || nothing}
          @input=${this._onInput}
          @change=${this._onChange}>
        ${this.unit ? html `<span class="bw-input-unit">${this.unit}</span>` : nothing}
      </span>
    `;
    }
};
__decorate([
    property({ type: String, reflect: true })
], BwInput.prototype, "type", void 0);
__decorate([
    property({ type: String })
], BwInput.prototype, "value", void 0);
__decorate([
    property({ type: String })
], BwInput.prototype, "placeholder", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], BwInput.prototype, "disabled", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], BwInput.prototype, "mono", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], BwInput.prototype, "invalid", void 0);
__decorate([
    property({ type: String })
], BwInput.prototype, "unit", void 0);
__decorate([
    property({ type: Number })
], BwInput.prototype, "min", void 0);
__decorate([
    property({ type: Number })
], BwInput.prototype, "max", void 0);
__decorate([
    property({ type: Number })
], BwInput.prototype, "step", void 0);
__decorate([
    property({ type: Number })
], BwInput.prototype, "maxlength", void 0);
__decorate([
    property({ type: String })
], BwInput.prototype, "inputmode", void 0);
__decorate([
    property({ type: String, attribute: 'aria-describedby' })
], BwInput.prototype, "fwdDescribedBy", void 0);
BwInput = __decorate([
    customElement('bw-input')
], BwInput);
export { BwInput };
//# sourceMappingURL=bw-input.js.map